import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

// const scrollHeaders = ["Buying Guides", "Reasons to Upgrade", "Product News", "Popular Products", "Technical Insight"]

const { useRef, useEffect, useState } = React;

const ScrollWidget = (props) => {
    const [cards, setCards] = useState([]);
    // const [scrollHeaders, setScrollHeaders] = useState([]);

    useEffect(() => {
        fetch(props.url)
            .then((response) => response.json())
            .then(setCards);
    }, []);

    const scrollArea = useRef(null);

    function scroll(scrollOffset) {
        return scrollArea.current.scrollLeft += scrollOffset;
    }

    // function changeExtension(jpgVersion) {
    //     const jpgVersion = path.basename(file, path.extname(file));
    //     return path.join(path.dirname(file), basename + extension);
    // }

    // function changeExtension(jpgVersion) {
    //     if(rejectedFiles.length){
    //         rejectedFiles.forEach(file => {
    //             if(file.type == "image/jpeg" && file.type == "image/png"){
    //                 console.log("hi");
    //             } else if (file.type == "image/webp"){
    //                 console.log("it works");
    //             }
    //         });
    //     }
    // }




    // handleDropRejection(rejectedFiles) {
    //     if(rejectedFiles.length){
    //         rejectedFiles.forEach(file => {
    //             if(file.type !== "image/jpeg" && file.type !== "image/png"){
    //                 toastr.error(`Your image with name ${file.name} is not accepted. Make sure your image has either a .jpg or .png extension. Example: 'product.jpg'`);
    //             } else if (file.size > 5000000){
    //                 toastr.error(`Your image with name ${file.name} is too large. It is ~${(file.size / 1000000).toFixed(1)}MB. Please upload an image with a file size of under 5MB.`);
    //             }
    //         });
    //     }
    // }

    return (
        <div>
            <div className="resources__belt resources__belt--secondary">
                <div className="resources__full">
                    <h2 className="resources__h2">{props.title}</h2>
                    <div className="resources__row">
                        <div ref={scrollArea} className="resources__items scrollsnap--element resources__items--full">
                            {cards.map(function(card) {
                                return <ArticleCard title={card.title} date={card.creation_time}  author={card.user_id} key={card.post_id} image={"https://cdn.labx.com/" + card.thumbnail} identifier={card.identifier} post_id={card.post_id} short_content={props.show_short_content && card.short_content} category={props.show_category && card.category_name} />;
                            })}
                        </div>
                        <button onClick={() => scroll(-300)} className="scrollsnap__left__button">
                            <svg  className="svg-inline--fa fa-chevron-left fa-w-10 widget-arrow" aria-hidden="true" data-prefix="fas" data-icon="chevron-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" data-fa-i2svg=""><path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path>
                            </svg>
                        </button>
                        <button onClick={() => scroll(300)} className="scrollsnap__right__button">
                            <svg className="svg-inline--fa fa-chevron-right fa-w-10 widget-arrow" aria-hidden="true" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" data-fa-i2svg=""><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

function ArticleCard(props) {
    const changeFileExtension = (url, to_ext) => url.substr(0, url.lastIndexOf(".")) + "." + to_ext;

    return (
        <a className="resources__item resources__item--full" href={`/resources/${props.identifier}/${props.post_id}`}>
            <picture className="resources__picture">
                <source srcSet={changeFileExtension(props.image, "webp")} type="image/webp"/>
                <img className="resources__image" src={props.image} width="300" height="150" loading="lazy" onError={pictureTagFallback}/>
            </picture>
            <div className="resources__block">
                <div className="resources__dateAndCategory">
                    <p className="resources__p resources__scroll__article__date">{props.date}</p>
                    {props.category && <p className="latestCategory">{props.category}</p>}
                </div>
                <h3 className="resources__h3 resources__scroll__article__title">{props.title}</h3>
                {/* <p>{props.short_content}</p> */}
                {props.short_content && <p className="resources__scroll__article__description">{props.short_content}</p>}
                {/* <p className="resources__p">{props.author}</p> */}
            </div>
        </a>
    );
}

{/* <element class="resources__belt--secondary"> */}


ArticleCard.propTypes = {
    title: PropTypes.string,
    header: PropTypes.string,
    date: PropTypes.string,
    author: PropTypes.string,
    key: PropTypes.number,
    image: PropTypes.string,
    identifier: PropTypes.string,
    post_id: PropTypes.string,
    short_content: PropTypes.string,
    category: PropTypes.string
};

ScrollWidget.propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    show_category: PropTypes.bool,
    show_short_content: PropTypes.bool
};



export default ScrollWidget;

//  <a href={`/resources/${props.identifier}/${props.post_id}`}>